/** The account's payment settings: whether the system check may give a first signature. */
import { useMutation, useQuery } from '@apollo/client/react';
import { PaymentSettingsDocument, UpdatePaymentSettingsDocument } from '@/graphql';

export function usePaymentSettings() {
  const { data, loading, error } = useQuery(PaymentSettingsDocument);
  const [updateMutation, { loading: saving }] = useMutation(UpdatePaymentSettingsDocument, {
    errorPolicy: 'none',
    // The settings carry no id: write the answer over the read so the switch follows it.
    update(cache, result) {
      const paymentSettings = result.data?.updatePaymentSettings;
      if (paymentSettings)
        cache.writeQuery({ query: PaymentSettingsDocument, data: { paymentSettings } });
    }
  });

  const setSystemCheckEnabled = async (isBankAccountSystemCheckEnabled: boolean) => {
    await updateMutation({ variables: { input: { isBankAccountSystemCheckEnabled } } });
  };

  return {
    isSystemCheckEnabled: data?.paymentSettings.isBankAccountSystemCheckEnabled ?? false,
    loaded: data !== undefined,
    loading,
    saving,
    error,
    setSystemCheckEnabled
  };
}
